class File {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(function(){
      $("input[type='file']").on('change',function(){
         var file = $(this).prop('files')[0];
         if(!($(".filename").length)){
           $("#input-group").append('<span class="filename"></span>');
         }
         $("#file").addClass('changed');
         $(".filename").html(file.name);
       });
     });

  }
}
